<app-form-admindelegate
    [result]="selectedResult"
    [delegateList]="delegateList"
    [delegateBase]="delegateBase"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-admindelegate>

